const TENANT_STORAGE_KEY = 'active_tenant_id';

export function getActiveTenantId(): string {
  const storedTenantId = localStorage.getItem(TENANT_STORAGE_KEY);
  if (!storedTenantId || storedTenantId === 'dex_dev') {
    localStorage.setItem(TENANT_STORAGE_KEY, 'dex');
    return 'dex';
  }
  return storedTenantId;
}

export function setActiveTenantId(tenantId: string): void {
  localStorage.setItem(TENANT_STORAGE_KEY, tenantId);
}
